export const environment = {
  production: false,
  API_URL: "https://api.brandshow.vip/v1",
  imageUrl: "https://api.brandshow.vip/media/",
};
